export const validateLoanData = (data) => {
  let errors = {};

  if (!data.type) errors.type = "Type is required.";
  if (!data.date) errors.date = "Date is required.";
  if (!data.amount || isNaN(data.amount))
    errors.amount = "Valid Amount is required.";
  if (!data.vendorname) errors.vendorname = "Vendor Name is required.";
  if (!data.paymentmethod) errors.paymentmethod = "Payment Method is required.";

  return errors;
};
